/* export const HOST = "http://192.168.3.4:9800/api/v1/";
export const IMG_HOST = "http://192.168.3.4:9800"; */

export const HOST = "https://manager.ivxfx.com/api/v1/";
export const IMG_HOST = "https://manager.ivxfx.com";